/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { createApiResponseSchema, type IAPI } from '../../apiResponse';
import { genreSentimentSchema, type IGenreSentiment } from '../genre-sentiment-schema';
import { type IMovieRatingTotals, movieRatingTotalsSchema } from '../movie-rating-totals-schema';

const movieTasteDataSchema = z.object({
  genres: z.array(genreSentimentSchema),
  totals: movieRatingTotalsSchema,
});

export interface IMovieTasteData {
  genres: IGenreSentiment[];
  totals: IMovieRatingTotals;
}

export const getMovieTasteV1ResponseSchema = createApiResponseSchema(
  movieTasteDataSchema,
) as z.ZodSchema<IAPI<IMovieTasteData>>;

export type IGetMovieTasteV1Response = IAPI<IMovieTasteData>;
